<template>
  <!-- AREA DA TABELA INICIO -->
  <div class="px-4 sm:px-6 lg:px-8 mb-12">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold leading-6 text-gray-900">{{ headerInfo.title }}</h1>
        <p class="mt-2 text-sm text-gray-700">{{ headerInfo.description }}</p>
      </div>
      <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex sm:space-x-4">
        <!-- Botões para o caso de useForms ser true -->
        <template v-if="filterOnly">
          <button 
            @click="filterOpen"
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Filtro
          </button>
        </template>
        <!--
        <template v-if="importCustom">
          <button 
            @click="filterOpen"
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
          </button>
        </template>
        -->

        <template v-else-if="useForms">
          <button 
            v-if="importFile && podeDeletar"  
            @click="uploadOpen = true" 
            type="button" 
            class="block flex-1 rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Importar
          </button>
          <button 
            v-if="updateFile" 
            @click="openUpdateModal();"
            :fileOnlyState="true"
            type="button" 
            class="block flex-1 rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Atualizar
          </button>
          <button 
            @click="open = true" 
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Novo
          </button>
          <button 
            @click="filterOpen"
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Filtro
          </button>
        </template>

        <template v-else>
          <button 
            v-if="importFile && podeDeletar" 
            @click="uploadOpen = true" 
            type="button" 
            class="block flex-1 rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Importar
          </button>
          <button 
            v-if="updateFile" 
            @click="openUpdateModal();"
            :fileOnlyState="true"
            type="button" 
            class="block flex-1 rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Atualizar
          </button>
          <button 
            @click="newAlternative" 
            type="button" 
            class="block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Novo 
          </button>
          <button 
            @click="filterOpen"
            type="button" 
            class="block w-full rounded-md bg-customPurple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Filtro
          </button>
        </template>
      </div> 
    </div>
        <div class="mt-8 flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th v-for="header in headersData" :key="header.id" 
                        scope="col" 
                        class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                        {{ header }}
                      </th>
                    <th scope="col" class="sticky acao-coluna-cabecalho  whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                      <span class="sr-only">Ações</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-for="data in listingData" :key="data.id" class="hover:bg-gray-100">
                      <template v-for="(value, key) in data" :key="key">
                       <td
                          v-if="key !== 'id' && key !== 'dependente_id'"
                          class="whitespace-nowrap px-2 py-2 text-sm text-gray-500"
                        >
                          <template v-if="acaoEspecialPara(key)">
                            <a
                              :href="data[key]"
                              target="_blank"
                              class="text-blue-600 hover:underline"
                            >
                              {{ getNomeAcaoEspecial(key) }}
                            </a>
                          </template>
                          <template v-else>
                            {{ value }}
                          </template>
                        </td>
                      </template>
                      <td class="sticky acao-coluna whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                        <div class="flex-acoes">
                          <!--  Se houver ações customizadas -->
                          <template v-if="customActions && customActions.length > 0">
                            <a
                              v-for="(acao, index) in customActions"
                              :key="index"
                              href="#"
                              @click="emitirAcaoCustomizada({ nome: acao.nome, data,field: acao.field })"
                              class="text-customPurple hover:text-indigo-900"
                            >
                              {{ acao.nome }}<span class="sr-only">, {{ data.id }}</span>
                            </a>
                          </template>

                          <!--  Se estiver usando formulário customizado -->
                          <template v-else-if="useForms === true">
                             <td class="sticky acao-coluna whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                                <a href="#" @click="editConfirmation(data.id); editingOpen = true" class="text-customPurple hover:text-indigo-900">
                                  Editar<span class="sr-only">, {{ data.id }}</span>
                                </a>
                                <a v-if="podeDeletar()" @click="deleteData(data.id)" href="#" class="text-customPurple hover:text-indigo-900">
                                  Deletar<span class="sr-only">, {{ data.id }}</span>
                                </a>
                                <a href="#" @click="viewConfirmation(data.id); viewOpen = true" class="text-customPurple hover:text-indigo-900">
                                  Visualizar<span class="sr-only">, {{ data.id }}</span>
                                </a>
                              </td>
                          </template>
                          <!--  Bloco padrão -->
                          <template v-else-if="useForms === false">
                            <td class="sticky acao-coluna whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                              <div class="flex-acoes">
                                <a href="#" @click="editAlternative(data.id, data.tipo || null)" class="text-customPurple hover:text-indigo-900">
                                  Editar<span class="sr-only">, {{ data.id }}</span>
                                </a>
                                <a v-if="podeDeletar()" @click="deleteData(data.id)" href="#" class="text-customPurple hover:text-indigo-900">
                                  Deletar<span class="sr-only">, {{ data.id }}</span>
                                </a>
                                <a v-if="useView === true" href="#" @click="viewAlternative(data.id)" class="text-customPurple hover:text-indigo-900">
                                  Visualizar<span class="sr-only">, {{ data.id }}</span>
                                </a>
                              </div>
                            </td>
                          </template>
                        </div>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="flex justify-between items-center mt-2.5 space-x-4">
          <div class="flex items-center">
            <span class="text-sm text-gray-600">Página {{ currentPage }} de {{ totalPages }} | Total de registros: {{ totalRecords }}</span>
          </div>
          <div class="flex sticky items-center space-x-2">
            <button @click="previousPage" v-if="previous" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
            <button @click="nextPage" v-if="next" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
            <input type="number" v-model="pageNumber" min="1" :max="totalPages" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
            <button @click="goToPage" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- COMPONENTE DE CADASTRO INICIO -->
    <CommonForm
      :open= "open"
      :extraInputName= "extraInputName"
      @update-open= "open = false"
      :inputsList="inputsListing"
      :extraInputs= "extraInputs"
      :title= "headerInfo.title"
      @data= "sendFormData"
      :resetFormData= "resetFormData"
    />
  <!-- COMPONENTE DE EDIÇÃO INICIO -->
    <CommonEditingForm
      :open= "editingOpen"
      :extraInputName= "extraInputName"
      :resetFormData= "resetFormData"
      :inputsList="inputsListing"
      :placeHolderValues= "editFormData"
      @editing-data= "sendEditingData"
      @update-open= "editingOpen = false"
    />
  <!-- COMPONENTE DE VISUALIZAÇÃO INICIO -->
   <CommonView
    :title ="headerInfo.title"
    :data ="editFormData"
    :open= "viewOpen"
    @update-open= "viewOpen = false"
   />
  <!-- COMPONENTE DE VISUALIZAÇÃO FIM -->
   <CommonUpload
      v-if="importFile"
     :open= "uploadOpen"
     :fileOnly="fileOnlyState"
     :update="updateFile"
     :selectBoxItems= "selectBoxItems"
     @file-data= "sendUploadData"
     @update-open= "uploadOpen = false"
   />
</template>
<script>

import CommonForm from './CommonForm.vue';
import CommonEditingForm from './CommonEditingForm.vue';
import CommonView from './CommonView.vue';
import CommonUpload from './CommonUpload.vue';

  export default {
    name: 'CommonListing',
    async created(){
      
    },
    emits: [
      'previous-page', 
      'next-page', 
      'go-to-page', 
      'find-by-field', 
      'clean-filter',
      'send-form-data',
      'delete-data-id',
      'edit-confirmation',
      'send-editing-data',
      'view-confirmation',
      'upload-data',
      'edit-alternative',
      'view-alternative',
      'new-alternative',
      'filter',
      'acao-customizada'
    ],
    props: {
      listingData: {
        type: Array,
        required: false
      },
      acoesEspeciais: {
        type: Array,
        default: () => []
      },
       customActions: {
        type: Array,
        default: () => []
      },
      headersData: {
        type: Array,
        required: true
      },
      inputsListing:{
        type: Array,
        required: false
      },
      headerInfo: {
        type: Object,
        required: true
      },
      previous: {
        type: String,
        required: true,
      },
      next: {
        type: String,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
      totalPages: {
        type: Number,
        required: true,
      },
      totalRecords: {
        type: Number,
        required: true,
      },
      extraInputs: {
        type: Array,
        required: false,
      },
      resetFormData:{
        type: Boolean,
        required:true
      },
      extraInputName: {
        type: String,
        required: false
      },
      editFormData: {
        type: Object,
        required: false
      },
      importFile:{
        type: Boolean,
        required:true
      },
      selectBoxItems: {
        type: Array,
        required: false,
      },
      useForms: {
        type: Boolean,
        required: true,
      },
      useView: {
        type: Boolean,
        required: false,
      },
      fileOnly: {
        type: Boolean,
        required: true,
      },
      updateFile: {
        type: Boolean,
        required: false,
      },
       filterOnly: {
        type: Boolean,
        default: false // <-- aqui está a nova prop
      },
    },
    data() {
      return {
        headerInfoData:this.headerInfo,
        pageNumber: 1,
        open: false,
        editingOpen: false,
        viewOpen:false,
        uploadOpen: false,
        fileOnlyState: this.fileOnly,
      };
    },
    methods: {
      previousPage() {
        this.$emit('previous-page', this.previous);
      },
      nextPage() {
        this.$emit('next-page', this.next);
      },
      goToPage() {
        this.$emit('go-to-page', this.pageNumber);
      },
      sendFormData(formData){
        this.$emit('send-form-data', formData);
      },
      sendEditingData(editData,id){
        this.$emit('send-editing-data', editData,id);
      }
      ,
      deleteData(id){
        this.$emit('delete-data-id', id);
      }
      ,
      editConfirmation(id){
        this.$emit('edit-confirmation',id);
      },
      viewConfirmation(id){
        this.$emit('view-confirmation',id);
      },
      sendUploadData(data){
        this.uploadOpen = false;
        this.fileOnlyState = false;
        this.$emit('upload-data',data);
      },
      editAlternative(id, tipo = null) {
        if (tipo) {
          this.$emit('edit-alternative', { id, tipo });
        } else {
          this.$emit('edit-alternative', id);
        }
      },
      viewAlternative(id) {
        this.$emit('view-alternative', id);
      },
      newAlternative() {
        this.$emit('new-alternative');
      },
      filterOpen(){
        this.$emit('filter');
      },
      openUpdateModal() {
        console.log(this.fileOnlyState)
        this.fileOnlyState = true;
        this.uploadOpen = true; 
        console.log(this.fileOnlyState)
      },
      podeDeletar() {
        const user = JSON.parse(window.localStorage.getItem("myUser"));
        const grupos = user?.user?.groups || [];
        const permitidos = ['master', 'roteirizacao', 'gcp-organization-admins'];
        return grupos.some(g => permitidos.includes(g));
      },
      acaoEspecialPara(campo) {
        return this.acoesEspeciais.some(acao => acao.campo === campo);
      },
      getNomeAcaoEspecial(campo) {
        const acao = this.acoesEspeciais.find(acao => acao.campo === campo);
        return acao ? acao.nome_exibicao : campo;
      },
      emitirAcaoCustomizada(acao) {
        if (!acao?.field || !acao?.data) {
          console.error('Campo ou dados ausentes:', acao);
          return;
        }

        const valorExtraido = acao.data[acao.field];

        this.$emit('acao-customizada', {
          nome: acao.nome,
          data: valorExtraido
        });
      }
    },
    components:{
      CommonForm,
      CommonEditingForm,
      CommonView,
      CommonUpload
    }
  }
</script>
<style scoped>
.acao-coluna-cabecalho.acao-coluna {
  position: sticky;
  right: 0;
  z-index: 10;
  text-align: center;
  width: 150px;
}
.acao-coluna {
  position: sticky;
  right: 0;
  z-index: 10;
  text-align: center;
  width: 150px;
  background-color: white;
}
.flex-acoes {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 8px;
}

</style>